'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _validationIcon = require('./validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.input.withConfig({
  componentId: 's136inmp-0'
})(['box-sizing:border-box;margin:0 0 calc(', ' / 2);font-size:0.9em;line-height:', ';font-family:inherit;width:100%;border:1px solid ', ';background-color:', ';border-radius:', ';padding:calc(', ' / 4) calc(', ' / 2);&:focus{outline:none;box-shadow:0 0 2px 3px ', ';}&:disabled{background-color:', ';}&::placeholder{color:', ';}', ' &[type="range"] + ', '{position:absolute;right:-22px;top:5px;}'], function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.inputLineHeight;
}, function (p) {
  return p.theme.borderColor;
}, function (p) {
  return p.theme.inputBgColor;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.focusColor;
}, function (p) {
  return p.theme.inputDisabledBgColor;
}, function (p) {
  return p.theme.placeholderColor;
}, function (p) {
  return p.error && '\n    border-color: ' + p.theme.errorColor + ';\n    background-color: ' + p.theme.errorBgColor + ';\n\n    &::placeholder {\n      color: ' + p.theme.errorColor + ';\n    }\n  ';
}, _validationIcon2.default);